// extracted by mini-css-extract-plugin
export default {"screenArea":"_1g1Yn7q6P1uwK4Rj9o3QGo height-100 position-absolute width-100"};